import { Router } from "@angular/router";
// Third party packages
// Custom packages
import { PUBLIC_QR_LEGACY_DATA_KEY, publicQrLegacyRedirectCommands, } from "src/app/modules/public-qr-v3/public-qr-v3-legacy-redirect.utils";
import { isArchiveV3Live } from "src/app/shared/utils/archive-switch.utils";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
/**
 * The stickers already printed of the archive (documents, areas, sections, the first platform's
 * areas), once the new archive is live: the legacy public page hands them to the new one
 * (@see publicQrLegacyRedirectCommands), which reads them through the legacy routes of NEW-A3.
 *
 * Switch off, nothing changes: the legacy page opens, with its calls of today. The query goes along,
 * so the names the app passes still skip the form.
 *
 * A guard and not a choice in the route table, as `ArchiveV3RedirectGuard`: the routes stay static for
 * the AOT compiler.
 *
 * @since 3.0.0
 */
var PublicQrV3LegacyGuard = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PublicQrV3LegacyGuard(router) {
        this.router = router;
    }
    /**
     * The new page when the new archive is live, the legacy page otherwise.
     *
     * @since 3.0.0
     */
    PublicQrV3LegacyGuard.prototype.canActivate = function (route) {
        var data = route && route.data ? route.data : {};
        var commands = publicQrLegacyRedirectCommands(this.archiveLive(), data[PUBLIC_QR_LEGACY_DATA_KEY], route ? route.params : null);
        if (!commands) {
            return true;
        }
        return this.router.createUrlTree(commands, { queryParams: route.queryParams });
    };
    /**
     * Whether the new archive is live; a method so that a test can turn it on.
     *
     * @since 3.0.0
     */
    PublicQrV3LegacyGuard.prototype.archiveLive = function () {
        return isArchiveV3Live();
    };
    PublicQrV3LegacyGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PublicQrV3LegacyGuard_Factory() { return new PublicQrV3LegacyGuard(i0.ɵɵinject(i1.Router)); }, token: PublicQrV3LegacyGuard, providedIn: "root" });
    return PublicQrV3LegacyGuard;
}());
export { PublicQrV3LegacyGuard };
